import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Wrench, Flame, Droplets, Bath, Paintbrush, Settings, Siren } from "lucide-react";
import SEO from "../components/SEO";
import { services } from "../data/content";
import { serviceImages } from "../data/images";
import { getBreadcrumbJsonLd } from "../data/jsonld";

const iconMap = { Wrench, Flame, Droplets, Bath, Paintbrush, Settings, Siren };

export default function Services() {
  return (
    <>
      <SEO
        title="Nos Services Plomberie & Chauffage à Meaux (77) | Pereira Plomberie"
        description="Découvrez tous nos services : dépannage plomberie, installation sanitaire, chauffage, recherche de fuites, rénovation salle de bain. Artisan local à Meaux."
        jsonLd={getBreadcrumbJsonLd([
          { name: "Accueil", url: "/" },
          { name: "Services" },
        ])}
      />

      {/* Header */}
      <section className="bg-primary text-white py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-sm font-accent font-medium tracking-widest text-secondary uppercase mb-2">Notre expertise</p>
          <h1 className="font-heading text-4xl md:text-6xl font-bold uppercase tracking-tight" data-testid="services-title">
            Nos services en plomberie et chauffage
          </h1>
          <p className="text-slate-300 mt-4 max-w-2xl text-lg">
            De la réparation urgente à l'installation neuve, nous intervenons sur tous vos besoins en plomberie et chauffage à Meaux et dans un rayon de 25 km.
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {services.map((service) => {
              const Icon = iconMap[service.icon];
              const img = serviceImages[service.slug];
              return (
                <Link
                  key={service.slug}
                  to={`/services/${service.slug}`}
                  className="group flex flex-col sm:flex-row gap-0 sm:gap-6 bg-white overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 rounded-sm"
                  data-testid={`service-item-${service.slug}`}
                >
                  {img && (
                    <div className="sm:w-48 h-48 sm:h-auto flex-shrink-0 overflow-hidden">
                      <img src={img.url} alt={img.alt} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                    </div>
                  )}
                  <div className="flex-1 p-6 border-l-4 border-secondary">
                    <div className="flex items-center gap-3 mb-2">
                      <div className="flex-shrink-0 w-10 h-10 bg-primary flex items-center justify-center rounded-sm group-hover:bg-secondary transition-colors">
                        <Icon size={20} className="text-white" />
                      </div>
                      <h2 className="font-heading text-xl font-semibold uppercase tracking-wide">{service.title}</h2>
                    </div>
                    <p className="text-sm text-slate-600 leading-relaxed mb-2">{service.shortDesc}</p>
                    <p className="text-xs text-slate-500 mb-3">{service.benefit}</p>
                    <span className="inline-flex items-center gap-1 text-secondary text-sm font-bold uppercase tracking-wider group-hover:gap-2 transition-all">
                      Découvrir <ArrowRight size={14} />
                    </span>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}
